import { Form, Input, Button, Divider } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useLoading from '../../../../hooks/useLoading';

export type Props = {
  onSubmit: (email: string, newPassword: string) => void;
  failedCallback?: (info: any) => void;
};
const VerifyResetPasswordForm = (props: Props) => {
  const { onSubmit, failedCallback = () => {} } = props;
  const { t } = useTranslation();
  const { isLoading, startLoading, stopLoading } = useLoading();

  const onFinish = async (values: any) => {
    startLoading();
    await onSubmit(values.email, values.password);
    stopLoading();
  };

  const onFinishFailed = (errorInfo: any) => {
    failedCallback(errorInfo);
  };

  return (
    <Form
      name="resetPasswordForm"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      style={{ width: '100%' }}
      layout="vertical"
    >
      <Form.Item
        label={t('auth.email')}
        name="email"
        rules={[
          { required: true, message: t('common.required') },
          { type: 'email', message: t('auth.invalidEmail') },
        ]}
      >
        <Input size="large" prefix={<MailOutlined />} />
      </Form.Item>
      <Form.Item
        label={t('auth.password')}
        name="password"
        rules={[
          { required: true, message: t('common.required') },
          { min: 6, message: t('auth.passwordMin') },
        ]}
        hasFeedback
      >
        <Input.Password size="large" prefix={<LockOutlined />} />
      </Form.Item>
      <Form.Item
        label={t('auth.passwordConfirm')}
        name="passwordConfirm"
        rules={[
          { required: true, message: t('common.required') },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t('auth.passwordMismatch')));
            },
          }),
        ]}
        hasFeedback
      >
        <Input.Password size="large" prefix={<LockOutlined />} />
      </Form.Item>
      <Divider />
      <Form.Item>
        <Button
          size="large"
          type="primary"
          block
          htmlType="submit"
          loading={isLoading}
        >
          {t('auth.set')}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default VerifyResetPasswordForm;
